import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//img/icon-user-card.svg'


const _withScopeId = n => (_pushScopeId("data-v-4a27dd37"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "user__welcome-caption" }, "Добро пожаловать!", -1))
const _hoisted_3 = {
  key: 0,
  class: "user__welcome-text"
}
const _hoisted_4 = {
  key: 1,
  class: "user__welcome-text"
}
const _hoisted_5 = {
  key: 2,
  class: "user-panel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "user-card__img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = { class: "user-panel__card__caption" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

import router from "@/router";
import UserApi from "../api/UserApi";
import { onMounted, ref } from "vue";
import { useTestStore } from "@/store/UserTestModule";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserComponent',
  setup(__props) {

const api = new UserApi();
const assignedTests = ref([]);
const mainStore = useTestStore();

/* Starts the test based on the provided ID.*/
function startTest(id: number) {
  const isTestIdValid = mainStore.testId === id;
  const isCurrentQuestionNumberValid = mainStore.currentQuestionNumber !== 0 && mainStore.currentQuestionNumber !== null;
  
  if (isTestIdValid && isCurrentQuestionNumberValid) {
    router.push({ name: "test" });
  } else {
    mainStore.settestId(id);
    router.push({ name: "start" });
  }
}

async function loadAssignedTests() {
  await api.loadAssignedTests().then((res) => {
    assignedTests.value = res.assignedTests;
  });
}

onMounted(() => {
  loadAssignedTests();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (assignedTests.value.length > 0)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_3, " У вас есть непройденные тесты "))
      : (_openBlock(), _createElementBlock("h4", _hoisted_4, " У вас нет непройденных тестов. Хорошая работа! ")),
    (assignedTests.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assignedTests.value, (test, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "user-panel__card user-card",
              key: index
            }, [
              _hoisted_6,
              _createElementVNode("p", _hoisted_7, _toDisplayString(test.tesSetName), 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (startTest(test.testSetId)),
                class: "base-btn base-btn-yellow user-panel__card__btn"
              }, [
                (
              _unref(mainStore).testId === test.testSetId &&
              (_unref(mainStore).currentQuestionNumber !== 0 ||
                _unref(mainStore).currentQuestionNumber !== null)
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Продолжить"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "Пройти тест"))
              ], 8, _hoisted_8)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})